export const SONGSTYLE = [
  {
    name: "全部单曲",
    type: "One",
  },
  {
    name: "早场",
    type: "Two",
  },
  {
    name: "中场",
    type: "Three",
  },
  {
    name: "晚场",
    type: "Four",
  },
  {
    name: "特色套曲",
    type: "Five",
  },
 /* {
    name: "轻音乐",
    type: "Six",
  },
  {
    name: "BGM",
    type: "Seven",
  },
  {
    name: "乐器",
    type: "Eight",
  },*/
];
